/* Product page: gallery paging, quantity stepper, and variant selection
   (price, availability and the hidden variant id all follow the chosen options). */
(function () {
  function setup(root) {
    if (root.dataset.blPdpReady === '1') return;
    root.dataset.blPdpReady = '1';

    // ---- gallery ----
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bl-pdp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bl-pdp-thumb]'));
    var index = 0;

    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (el, n) {
        if (n === index) el.setAttribute('data-active', ''); else el.removeAttribute('data-active');
      });
      thumbs.forEach(function (el, n) {
        if (n === index) el.setAttribute('data-active', ''); else el.removeAttribute('data-active');
      });
    }

    var next = root.querySelector('[data-bl-pdp-next]');
    if (next) next.addEventListener('click', function () { show(index + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.blPdpThumb, 10) || 0); });
    });

    // ---- quantity ----
    var qty = root.querySelector('[data-bl-pdp-qty]');
    var minus = root.querySelector('[data-bl-pdp-minus]');
    var plus = root.querySelector('[data-bl-pdp-plus]');
    function step(by) {
      if (!qty) return;
      var n = (parseInt(qty.value, 10) || 1) + by;
      qty.value = Math.max(1, n);
    }
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });

    // ---- variants ----
    var dataEl = root.querySelector('[data-bl-pdp-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idField = root.querySelector('[data-bl-pdp-variant-id]');
    var priceEl = root.querySelector('[data-bl-pdp-price]');
    var wasEl = root.querySelector('[data-bl-pdp-was]');
    var atc = root.querySelector('[data-bl-pdp-atc]');
    var atcText = root.querySelector('[data-bl-pdp-atc-text]');
    var wallet = root.querySelector('.bl-pdp__wallet');
    var buybar = root.querySelector('.bl-pdp__buybar');

    /* On mobile the buy bar is pinned to the bottom, and the page reserves room
       for it. Its height is not a constant — the wallet button and the optional
       link underneath both change it — so measure it instead of trusting a
       hand-entered number. */
    function measureBar() {
      if (!buybar) return;
      document.documentElement.style.setProperty('--bl-buybar-h', buybar.offsetHeight + 'px');
    }
    measureBar();
    if (window.ResizeObserver && buybar) new ResizeObserver(measureBar).observe(buybar);
    window.addEventListener('resize', measureBar);
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-bl-pdp-option]'));
    if (!optionInputs.length) return;

    // read both labels from the button: the rendered text is the sold-out
    // string when the first variant happens to be unavailable
    var addLabel = (atc && atc.dataset.blAdd) || (atcText ? atcText.textContent.trim() : '');
    var soldOutLabel = (atc && atc.dataset.blSoldout) || addLabel;

    // Money formatting is the store's job; mirror what Liquid already rendered
    // by reading the shape of the initial price string.
    var sample = priceEl ? priceEl.textContent.trim() : '';
    function money(cents) {
      var amount = (cents / 100);
      var text = amount % 1 === 0 ? String(amount) : amount.toFixed(2);
      // reuse the non-numeric parts of the server-rendered price (currency symbol/suffix)
      var prefix = sample.match(/^[^\d]*/);
      var suffix = sample.match(/[^\d.,]*$/);
      return (prefix ? prefix[0] : '') + text.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (suffix ? suffix[0] : '');
    }

    function selected() {
      var chosen = [];
      optionInputs.forEach(function (input) {
        if (input.checked) chosen[parseInt(input.dataset.blPdpOption, 10)] = input.value;
      });
      return chosen;
    }

    function match(chosen) {
      return variants.find(function (variant) {
        return chosen.every(function (value, i) { return variant.options[i] === value; });
      });
    }

    function update() {
      var variant = match(selected());

      if (!variant) {
        if (atc) { atc.disabled = true; }
        if (atcText) atcText.textContent = soldOutLabel;
        return;
      }

      if (idField) idField.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);

      if (wasEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          wasEl.textContent = money(variant.compare_at_price);
          wasEl.hidden = false;
          if (priceEl) priceEl.classList.remove('bl-pdp__price--plain');
        } else {
          wasEl.hidden = true;
          if (priceEl) priceEl.classList.add('bl-pdp__price--plain');
        }
      }

      if (atc) atc.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? addLabel : soldOutLabel;

      /* Shopify's accelerated-checkout button is rendered once by Liquid and
         does not know about variant changes, so it would stay clickable on a
         sold-out variant. Inline style rather than [hidden] because the theme
         sets display on its own elements. */
      if (wallet) wallet.style.display = variant.available ? '' : 'none';
      measureBar();

      // reflect the choice in the URL so the variant is shareable
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', update); });
  }

  function init() { document.querySelectorAll('[id^="bl-pdp-"]').forEach(setup); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
